import React, { Fragment, useState, createRef, ChangeEvent } from 'react'
import TextInput from 'tfs.form-text-input'

import NotificationInterface from '../../interfaces/client/Notification'

import getNotificationLabelFromCode from '../../utils/notifications/getNotificationLabelFromCode'

import GenderSelect from '../../containers/GenderSelect'

import FormCheckbox from '../FormCheckbox'

import globalStyles from '../../styles/global.module.scss'

interface EditBookingFormInfantRowPropsInterface {
  removeNotification: Function
  infantDateOfBirthValidator: Function
  validateInfantDateOfBirth: Function
  selectPassengerForDeletion: Function
  deselectPassengerForDeletion: Function

  rowId: number
  infantId: string
  passengerId: string
  firstName: string
  lastName: string
  dateOfBirth: string
  gender: string

  isInfantSelectedForDeletion: boolean
  isDeleteCheckboxDisabled: boolean
  isDeletePassengersEnabled: boolean
  isPassengerCheckedIn: boolean

  firstNameError?: NotificationInterface
  lastNameError?: NotificationInterface
  dateOfBirthError?: NotificationInterface
}

export default (props: EditBookingFormInfantRowPropsInterface) => {
  const {
    passengerId,
    infantId,
    rowId,
    firstName,
    lastName,
    dateOfBirth,
    gender,
    firstNameError,
    lastNameError,
    dateOfBirthError,
    removeNotification,
    validateInfantDateOfBirth,
    infantDateOfBirthValidator,
    isDeletePassengersEnabled,
    isPassengerCheckedIn,
    isDeleteCheckboxDisabled,
    isInfantSelectedForDeletion,
    selectPassengerForDeletion,
    deselectPassengerForDeletion,
  } = props

  const [infant, setInfant] = useState({
    firstName,
    lastName,
    dateOfBirth,
    gender,
  })

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const target = event.currentTarget

    setInfant({
      ...infant,
      [String(target.dataset.name)]: target.value,
    })

    if (target.dataset.errorId) {
      removeNotification(target.dataset.errorId)
    }
  }

  const handleDateOfBirthChange = (event: ChangeEvent<HTMLInputElement>) => {
    handleChange(event)

    validateInfantDateOfBirth(
      event.currentTarget,
      infantId,
      infantDateOfBirthValidator,
      dateOfBirthError
    )
  }

  const handleRemoveChange = (event: ChangeEvent<HTMLInputElement>) =>
    event.currentTarget.checked
      ? selectPassengerForDeletion(infantId)
      : deselectPassengerForDeletion(infantId)

  return (
    <Fragment>
      {isDeletePassengersEnabled &&
        (!isPassengerCheckedIn ? (
          <FormCheckbox
            elementRef={createRef()}
            name={`${passengerId}-infant-delete`}
            handleChange={handleRemoveChange}
            checked={isInfantSelectedForDeletion}
            disabled={isDeleteCheckboxDisabled}
            data-element="remove-passenger-input"
            data-passenger-id={infantId}
          />
        ) : (
          <span></span>
        ))}

      <span>
        <input
          className={globalStyles['shadow-input']}
          type="text"
          name={`${passengerId}-infant-id`}
          defaultValue={infantId}
        />
      </span>
      <span></span>

      <span className={globalStyles['input-wrapper']}>
        <TextInput
          elementRef={createRef()}
          name={`${passengerId}-infant-first-name`}
          data-element={`${rowId}-infant-first-name`}
          data-name="firstName"
          data-error-id={firstNameError ? firstNameError.id : ''}
          required={true}
          defaultValue={firstName}
          onChange={handleChange}
          data-changed={firstName !== infant.firstName}
          error={getNotificationLabelFromCode(firstNameError)}
          minvalue={1}
          readOnly={isDeletePassengersEnabled || isPassengerCheckedIn}
        />
      </span>

      <span className={globalStyles['input-wrapper']}>
        <TextInput
          elementRef={createRef()}
          name={`${passengerId}-infant-last-name`}
          data-element={`${rowId}-infant-last-name`}
          data-name="lastName"
          data-error-id={lastNameError ? lastNameError.id : ''}
          required={true}
          defaultValue={lastName}
          onChange={handleChange}
          data-changed={lastName !== infant.lastName}
          error={getNotificationLabelFromCode(lastNameError)}
          minvalue={1}
          readOnly={isDeletePassengersEnabled || isPassengerCheckedIn}
        />
      </span>

      <span className={globalStyles['input-wrapper']}>
        <TextInput
          elementRef={createRef()}
          name={`${passengerId}-infant-date-of-birth`}
          data-element={`${rowId}-infant-date-of-birth`}
          data-name="dateOfBirth"
          data-error-id={dateOfBirthError ? dateOfBirthError.id : ''}
          required={true}
          pattern="\d{2}-\d{2}-\d{4}"
          defaultValue={dateOfBirth}
          onChange={handleDateOfBirthChange}
          error={getNotificationLabelFromCode(dateOfBirthError)}
          data-changed={dateOfBirth !== infant.dateOfBirth}
          readOnly={isDeletePassengersEnabled || isPassengerCheckedIn}
        />
      </span>

      <span className={globalStyles['input-wrapper']}>
        <GenderSelect
          inputName={`${passengerId}-infant-gender`}
          refName={`${rowId}-infant-gender`}
          dataName="gender"
          isRequired={true}
          elementRef={createRef()}
          isDisabled={isDeletePassengersEnabled || isPassengerCheckedIn}
          defaultValue={gender}
          onChange={handleChange}
          dataChanged={gender !== infant.gender}
        />
      </span>
    </Fragment>
  )
}
